import { render, staticRenderFns } from "./RestrictionType.vue?vue&type=template&id=73f4d566&scoped=true&"
import script from "./RestrictionType.vue?vue&type=script&lang=js&"
export * from "./RestrictionType.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionType.vue?vue&type=style&index=0&id=73f4d566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4d566",
  null
  
)

export default component.exports